module.exports = __webpack_public_path__ + "media/application/images/icons/button-arrow-446566ab65470de66c28aeb0fd1fa1d1.svg";